import { getSublimationTemplateImageUrl } from '../utils/sublimationTemplatePreviewImage';

const IMAGE_BASE_URL = process.env.IMAGE_BASE_URL || 'https://images.uniformhero.com.au';

/**
 * Determine the URL for the image of a product colour
 * NOTE: The productSlug needs to be the root product slug, not the collection slug
 */
async function determineProductColourImageUrl({
  productSlug,
  colourPathName,
  colourObject,
  imageSize,
  imageType = 'jpg',
  gender = 'mens',
  availableGenders = ['mens', 'womens', 'youth'],
  side = 'front',
  showModel = true,
  isModelBasedImages = true,
  sublimationTemplateId = null,
  useCoverImageForPreview = false,
  previewImageDetails = {
    categorySlug: null,
    collectionSlug: null,
    printType: null,
    printPosition: null,
  },
}) {
  // Note the order of these if statements matters!
  if (!availableGenders.includes(gender)) {
    return 'img/design/not-available-for-gender.jpg';
  }
  if (!colourObject) {
    return 'img/design/not-available-for-colour.jpg';
  }
  if (
    previewImageDetails.categorySlug &&
    previewImageDetails.collectionSlug &&
    previewImageDetails.printType &&
    previewImageDetails.printPosition
  ) {
    return `${IMAGE_BASE_URL}/products/${productSlug}/preview/${previewImageDetails.categorySlug}/${previewImageDetails.collectionSlug}/${colourPathName}/${gender}-${colourPathName}-${productSlug}-${side}-${previewImageDetails.printType}-${previewImageDetails.printPosition}-${imageSize}px.${imageType}`;
  }
  if (sublimationTemplateId) {
    const response = await getSublimationTemplateImageUrl({
      productSlug,
      colourPathName,
      side,
      colours: {
        main: colourObject.ProductColoursMasterMain.rgb.replace(/\s+/g, ''), // Remove whitespace
        trim1: colourObject.ProductColoursMasterTrim1?.rgb
          ? colourObject.ProductColoursMasterTrim1.rgb.replace(/\s+/g, '')
          : undefined,
        trim2: colourObject.ProductColoursMasterTrim2?.rgb
          ? colourObject.ProductColoursMasterTrim2.rgb.replace(/\s+/g, '')
          : undefined,
        trim3: colourObject.ProductColoursMasterTrim3?.rgb
          ? colourObject.ProductColoursMasterTrim3.rgb.replace(/\s+/g, '')
          : undefined,
      },
      gender,
      size: imageSize,
      templateId: sublimationTemplateId,
      webp: imageType === 'webp',
    });
    if (!response.imageUrl) {
      return 'img/design/not-available-for-colour.jpg';
    }
    return response.imageUrl;
  }
  if (useCoverImageForPreview && side === 'front') {
    return `${IMAGE_BASE_URL}/products/${productSlug}/cover/${gender}-cover-${productSlug}-${side}-${imageSize}.${imageType}`;
  }
  if (isModelBasedImages) {
    return `${IMAGE_BASE_URL}/products/${productSlug}/${colourPathName}/${gender}-${colourPathName}-${productSlug}-${
      showModel ? 'model-' : ''
    }${side}-${imageSize}px.${imageType}`;
  }
  return `${IMAGE_BASE_URL}/products/${productSlug}/${colourPathName}/${gender}-${colourPathName}-${productSlug}-${side}-${imageSize}.${imageType}`;
}

export default determineProductColourImageUrl;
